import { render } from "./alimtalkComponent.vue?vue&type=template&id=1a1e1cf8"
import script from "./alimtalkComponent.vue?vue&type=script&lang=js"
export * from "./alimtalkComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__